<template>
    <div class="relevancy-tab">
        <!-- 关联的tab -->
        <div v-for="(item,i) in data" :key="i">
            <p>{{ item.title }}</p>
            <i class="iconfont icon-shanchu"　@click="delTab(item)"></i>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            data:Array,
            getData:Function
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {
            delTab(obj){
                let id = obj.serialNumber;
                let index;
                this.data.forEach((item,i)=> {
                    if(item.serialNumber == id){
                        index = i;
                    }
                });
                this.data.splice(index,1);
                this.getData(this.data);
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .relevancy-tab{
        >div{
            display: flex;
        }
        p{
            margin-right: 10px;
            width:100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        i{
            cursor: pointer;
            color: #F37258;
        }
    }
</style>
